module.exports = __webpack_public_path__ + "img/fengmian.9972be17.png";